var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 7,
    viewBox: "0 0 9 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.84184 0.599569C9.05272 0.810452 9.05272 1.15236 8.84184 1.36324L3.80184 6.40324C3.59095 6.61413 3.24905 6.61413 3.03816 6.40324L0.158162 3.52324C-0.0527208 3.31236 -0.0527208 2.97045 0.158162 2.75957C0.369045 2.54869 0.710955 2.54869 0.921838 2.75957L3.42 5.25773L8.07816 0.599569C8.28905 0.388685 8.63095 0.388685 8.84184 0.599569Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/TickIcon.07dfebb9570a56278dd98716cd123fd2.svg";
export { ForwardRef as ReactComponent };